// Os cinco tipos de ambiente, em UM lugar só.
//
// A lista morava dentro de `getTypeBadge`, em Ambients.tsx: um literal privado
// da tela. O modal de ambiente precisa das MESMAS cinco opções — se ele
// tivesse a própria cópia, um dia alguém acrescentaria um tipo de um lado e o
// selo do outro lado cairia no cinza "room" sem ninguém entender por quê.
//
// O `valor` é o que vai para a coluna `ambientType` de `acd."ActAmbient"` — a
// tela compara o texto do banco com a chave deste mapa, então o acento de
// "Produção" e "Logística" é parte do dado, não enfeite.
export interface TipoDeAmbiente {
  /** Gravado em `ambientType`. É também a chave do selo na tela. */
  valor: string;
  /** Ligatura do Material Icons. */
  icone: string;
  cor: string;
}

// Estes cinco rótulos são os MESMOS que o backend aceita: a lista
// `TIPOS_DE_AMBIENTE` de `ambient.handler.ts` recusa com 400 qualquer outro
// valor. Acrescentar um tipo aqui sem acrescentar lá derruba a gravação.
//
// Nenhum dos cinco muda o comportamento de outra tela — hoje `ambientType` é
// TEXT solto, usado só pelo selo colorido e pelo cadastro. Se um dia "Estoque"
// passar a habilitar algo (local de estoque, por exemplo), é aqui que a
// descrição desse efeito deve nascer, e só depois de existir de verdade.
export const TIPOS_DE_AMBIENTE: TipoDeAmbiente[] = [
  { valor: "Atendimento", icone: "people", cor: "#0066cc" },
  { valor: "Produção", icone: "kitchen", cor: "#28a745" },
  { valor: "Logística", icone: "local_shipping", cor: "#ffc107" },
  { valor: "Administrativo", icone: "business", cor: "#dc3545" },
  { valor: "Estoque", icone: "inventory_2", cor: "#6f42c1" },
];

/** Mapa nome -> aparência, no formato que `getTypeBadge` já consumia. */
export const TIPOS_DE_AMBIENTE_POR_NOME: {
  [nome: string]: { icon: string; color: string };
} = TIPOS_DE_AMBIENTE.reduce(
  (mapa, tipo) => ({ ...mapa, [tipo.valor]: { icon: tipo.icone, color: tipo.cor } }),
  {} as { [nome: string]: { icon: string; color: string } }
);

/**
 * Aparência de um tipo que não está na lista.
 *
 * Vale para dado antigo: enquanto `ambientType` for texto livre no banco,
 * pode existir linha com um tipo que ninguém mais oferece. Ela aparece com o
 * próprio nome em cinza, em vez de sumir da tela.
 */
export const APARENCIA_DE_TIPO_DESCONHECIDO = { icon: "room", color: "#6c757d" };
